import cn from "classnames"
import * as T from "trunx"

export function ButtonLink({ className, ...props }: T.AProps) {
    return <T.A {...props} className={cn(className, "blm-button button")} />
}
